<template>
  <div class="_a4-paper _fs-14">
    <div class="d-flex align-center pb-5">
      <div class="font-weight-bold _w-200 _fs-30">
        <div>
          {{ titleTextData.th }}
        </div>

        <div>
          {{ titleTextData.en }}
        </div>
      </div>
      <div class="pl-4 _flex-2">
        ( ต้นฉบับ / original )
      </div>
      <img
        class="_flex-1"
        src="../assets/sellsuki-logo.png"
        alt="Sellsuki Logo"
        height="75" />
    </div>

    <v-row>
      <v-col cols="8">
        <v-row no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              ลูกค้า /
            </span>
            Customer
          </v-col>
          <v-col
            v-if="isJuristicCustomer"
            cols="8">
            {{ companyText }}
            <template v-if="isJuristicCustomer">
              {{ branchNumberText }}
            </template>
          </v-col>
          <v-col
            v-else
            cols="8">
            {{ fullName }}
          </v-col>
        </v-row>

        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              ที่อยู่ /
            </span>
            Address
          </v-col>
          <v-col cols="8">
            {{ addressText }}
          </v-col>
        </v-row>

        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              เลขผู้เสียภาษี /
            </span>
            Tax ID
          </v-col>
          <v-col cols="8">
            {{ order.citizenId }}
          </v-col>
        </v-row>

        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              ผู้ติดต่อ /
            </span>
            Attention
          </v-col>
          <v-col cols="4">
            {{ fullName }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              Email:
            </span>
          </v-col>
          <v-col cols="8">
            {{ order.email }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="4">
            <span class="font-weight-bold">
              เบอร์โทรศัพท์:
            </span>
          </v-col>
          <v-col cols="8">
            {{ order.tel }}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="4">
        <v-row no-gutters>
          <v-col cols="6">
            <span class="font-weight-bold">
              เลขที่ /
            </span>
            No.
          </v-col>
          <v-col cols="6">
            {{ order.code }}
          </v-col>
        </v-row>

        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="6">
            <span class="font-weight-bold">
              วันที่ /
            </span>
            Issue
          </v-col>
          <v-col cols="6">
            <template v-if="order.createdAt">
              {{ order.createdAt | dateTimeFormat("DD/MM/YYYY") }}
            </template>
            <template v-else>
              -
            </template>
          </v-col>
        </v-row>

        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="6">
            <span class="font-weight-bold">
              ใช้ได้ถึง /
            </span>
            Valid
          </v-col>
          <v-col cols="6">
            <template v-if="validAt">
              {{ validAt | dateTimeFormat("DD/MM/YYYY") }}
            </template>
            <template v-else>
              -
            </template>
          </v-col>
        </v-row>
        <v-row
          class="mt-1"
          no-gutters>
          <v-col cols="6">
            <span class="font-weight-bold">
              อ้างอิง /
            </span>
            Ref.
          </v-col>
          <v-col cols="6">
            -
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-divider class="black"></v-divider>

    <v-row>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col cols="3">
            <div class="font-weight-bold">
              ผู้ออก
            </div>
            <div>
              Issuer
            </div>
          </v-col>
          <v-col cols="9">
            <div>
              บริษัท เซลสุกิ จำกัด (สำนักงานใหญ่)
            </div>
            <div class="pt-1">
              เลขที่ 10/39 ชั้น 3 ถนนรัชดาภิเษก แขวงจันทรเกษม เขตจตุจักร กรุงเทพมหานคร 10900
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row no-gutters>
          <v-col cols="7">
            <span class="font-weight-bold">
              เลขที่ผู้เสียภาษี /
            </span>
            Tax ID
          </v-col>
          <v-col cols="5">
            0105557075681
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="7">
            <span class="font-weight-bold">
              จัดเตรียมโดย /
            </span>
            Prepared by
          </v-col>

          <v-col cols="5">
            Sellsuki system
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="1">
            <span class="font-weight-bold">
              T:
            </span>
          </v-col>
          <v-col cols="4">
            02 026 3250
          </v-col>

          <v-col cols="1">
            <span class="font-weight-bold">
              E:
            </span>
          </v-col>
          <v-col cols="6">
            lineagency@sellsuki.com
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="1">
            <span class="font-weight-bold">
              W:
            </span>
          </v-col>
          <v-col cols="5">
            www.sellsuki.co.th
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <table>
      <thead>
        <tr>
          <th>
            <div class="font-weight-bold">
              รหัส
            </div>
            <div class="pt-3">
              ID no.
            </div>
          </th>

          <th colspan="2">
            <div class="_w-330">
              <div class="font-weight-bold">
                คำอธิบาย
              </div>
              <div class="pt-3">
                Description
              </div>
            </div>
          </th>

          <th>
            <div class="font-weight-bold">
              จำนวน
            </div>
            <div class="pt-3">
              Quantity
            </div>
          </th>

          <th>
            <div class="_w-100">
              <div class="font-weight-bold">
                ราคาต่อหน่วย
              </div>
              <div class="pt-3">
                Unit Price
              </div>
            </div>
          </th>

          <th>
            <div class="_w-100">
              <div class="font-weight-bold">
                มูลค่าก่อนภาษี
              </div>
              <div class="pt-3">
                Pre-Tax Amount
              </div>
            </div>
          </th>
        </tr>
      </thead>

      <tbody class="_vertical-align-top">
        <tr
          v-for="item in order.orderItems"
          :key="item._id"
        >
          <td>
            {{ item.productCode }}
          </td>
          <td colspan="2">
            {{ getProductName(item) }}
            <div v-if="item.productType === 'package'">
              <div class="_fs-10">
                วันที่เริ่มต้นใช้งานแพ็กเกจ: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
                ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
              </div>
            </div>
            <div v-if="item.productType === 'premiumId'">
              <div class="_fs-12">
                Premium ID: {{ item.premiumId }}
              </div>
              <div class="_fs-10">
                วันที่เริ่มต้นใช้งาน Premium ID: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
                ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
              </div>
            </div>
            <div v-if="item.productType === 'oaChat'">
              <div class="_fs-10">
                วันที่เริ่มต้นใช้งาน OA Chat: {{ item.startedAt | dateTimeFormat('YYYY-MM-DD') }}
                ถึง {{ item.expiredAt | dateTimeFormat('YYYY-MM-DD') }}
              </div>
            </div>
          </td>
          <td class="text-right">
            {{ item.itemQty | numberComma }}
          </td>
          <td class="text-right">
            {{ item.unitPrice | price }}
          </td>
          <td class="text-right">
            {{ item.itemAmount | price }}
          </td>
        </tr>
        <tr style="height: 50px;">
          <td></td>
          <td
            class="error--text font-weight-bold"
            colspan="2">
            * กรุณาชำระเงินตามยอดในใบเสนอราคาเท่านั้น หากชำระเงินไม่ครบถ้วน
            จะไม่สามารถเปิดให้บริการได้
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <!-- <tr><td></td><td colspan="2"></td><td></td><td></td><td></td></tr> -->
      </tbody>

      <tfoot class="_border-bottom-3">
        <tr>
          <td
            class="_vertical-baseline"
            :rowspan="isDeductWithholding ? 6 : 4"
            colspan="2">
            <div>
              <span class="font-weight-bold">
                หมายเหตุ /
              </span>
              Remarks
            </div>
            <div>
              กรณีโอนเงิน ธนาคารกสิกรไทย <br />
              สาขาเซ็นทรัลพลาซา แกรนด์ พระราม 9
            </div>
            <div>
              ชื่อบัญชี บจก.เซลสุกิ บัญชีออมทรัพย์ <br />
              เลขที่ 055-1-27809-3
            </div>
            <div>Basic ID: {{ basicId }}</div>
            <div v-if="order.displayName">
              <span>
                Display Name:
              </span>
              {{ order.displayName }}
            </div>
          </td>

          <td
            class="_border-bottom-1 _border-right-1"
            colspan="3">
            <div class="pa-2 text-right">
              <span class="font-weight-bold">
                ราคาสุทธิสินค้าที่เสียภาษี (บาท) /
              </span>
              Pre-VAT Amount
            </div>
          </td>
          <td class="text-right _border-bottom-1">
            {{ order.preVatAmount | price }}
          </td>
        </tr>

        <tr>
          <td
            class="_border-bottom-1 _border-right-1"
            colspan="3">
            <div class="pa-2 text-right">
              <span class="font-weight-bold">
                ภาษีมูลค่าเพิ่ม (บาท) /
              </span>
              VAT
            </div>
          </td>
          <td class="text-right _border-bottom-1">
            {{ order.vatAmount | price }}
          </td>
        </tr>

        <tr>
          <td
            class="_border-bottom-1 _border-right-1"
            colspan="3">
            <div class="pa-2 text-right">
              <span class="font-weight-bold">
                จำนวนเงินรวมทั้งสิ้น (บาท) /
              </span>
              Grand Total
            </div>
          </td>
          <td class="text-right _border-bottom-1">
            <span :class="isDeductWithholding ? undefined : 'font-weight-bold'">
              {{ order.grandTotal | price }}
            </span>
          </td>
        </tr>

        <!-- <tr>
          <td
            class="pa-2"
            :class="{ '_border-bottom-1': isDeductWithholding }"
            colspan="4"
            style="background-color: #EEEEEE;">
            <div class="font-weight-bold d-flex justify-space-around">
              <div class="pr-2">
                จำนวนเงินรวมทั้งสิ้น
              </div>

              <div>
                {{ grandTotalText }}
              </div>
            </div>
          </td>
        </tr> -->

        <template v-if="isDeductWithholding">
          <tr>
            <td
              class="_border-bottom-1 _border-right-1"
              colspan="3">
              <div class="pa-2 py-1 text-right">
                <span class="font-weight-bold">
                  ภาษีถูกหัก ณ ที่จ่าย (บาท) /
                </span>
                Withheld tax
              </div>
            </td>
            <td class="text-right _border-bottom-1">
              {{ order.withholdingTaxAmount | price }}
            </td>
          </tr>

          <tr>
            <td
              class="_border-bottom-1 _border-right-1"
              colspan="3">
              <div class="pa-2 py-1 text-right font-weight-bold">
                <span class="">
                  จำนวนเงินที่ต้องชำระ (บาท) /
                </span>
                Net to Pay
              </div>
            </td>
            <td class="text-right _border-bottom-1 font-weight-bold">
              {{ order.netTotal | price }}
            </td>
          </tr>
        </template>
      </tfoot>
    </table>

    <v-row>
      <v-col
        cols="4"
        offset="4">
        <div class="d-flex flex-column justify-space-between _h-100">
          <div class="text-center">
            <span class="font-weight-bold">
              อนุมัติโดย /
            </span>
            Approved by
          </div>
          <div>
            <hr class="_signature-border" />
            <div class="mt-1 d-flex align-baseline">
              <div
                class="mr-1"
                style="width: 105px;">
                วันที่ / Date
              </div>
              <hr
                class="_signature-border _w-100pct"
                style="height: 1px;" />
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="d-flex flex-column justify-space-between _h-100">
          <div class="text-center">
            <span class="font-weight-bold"> ยอมรับ{{ titleTextData.th }} / </span>
            Accepted by
          </div>
          <div>
            <hr class="_signature-border" />
            <div class="mt-1 d-flex align-baseline">
              <div
                class="mr-1"
                style="width: 105px;">
                วันที่ / Date
              </div>
              <hr
                class="_signature-border _w-100pct"
                style="height: 1px;" />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getProductName } from '../utils/order.util'

export default {
  name: 'DesktopLineDiyQuotation',
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    orderDetailType: {
      type: String,
      default: ''
    },
    basicId: {
      type: String,
      default: ''
    },
    premiumId: {
      type: String,
      default: ''
    },
    titleTextData: {
      type: Object,
      default: () => ({})
    },
    fullName: {
      type: String,
      default: ''
    },
    companyText: {
      type: String,
      default: ''
    },
    addressText: {
      type: String,
      default: ''
    },
    branchNumberText: {
      type: String,
      default: ''
    },
    validAt: {
      type: Date,
      default: undefined
    },
    packageStartedAt: {
      type: [String, Date],
      default: undefined
    },
    packageExpiredAt: {
      type: [String, Date],
      default: undefined
    },
    premiumIdStartedAt: {
      type: [String, Date],
      default: undefined
    },
    premiumIdExpiredAt: {
      type: [String, Date],
      default: undefined
    },
    grandTotalText: {
      type: String,
      default: ''
    },
    isJuristicCustomer: {
      type: Boolean,
      default: false
    },
    isDeductWithholding: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getProductName
  }
}
</script>

<style scoped>
._w-100 {
  width: 100px;
}

._w-200 {
  width: 200px;
}

._w-330 {
  width: 308px;
}

._w-100pct {
  width: 100%;
}

._h-100 {
  height: 100px;
}

._fs-14 {
  font-size: 14px;
}

._fs-30 {
  font-size: 30px;
}

._fs-36 {
  font-size: 36px;
}

._flex-1 {
  flex: 1;
}

._flex-2 {
  flex: 2;
}

._a4-paper {
  font-family: "Sarabun", sans-serif;
  background: white;
  display: block;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  margin: auto;

  width: 21cm;
  /* height: 29.7cm; */
  padding: 48px;
  padding-top: 24px;
}

._vertical-baseline {
  vertical-align: baseline;
}

._border-right-1 {
  border-right-width: 1px;
}

._border-bottom-1 {
  border-bottom-width: 1px;
}

._border-bottom-3 {
  border-bottom: 3px solid black;
}

._signature-border {
  border-width: thin;
  border-color: black;
  border-style: dashed;
}

table {
  width: 100%;
  height: 530px;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: left;
}

table tr > th,
table tr > td {
  border-style: solid;
  border-color: black;
}

table thead tr > th {
  font-weight: normal;
  border-width: 1px 0;
  padding: 14px 5px;
}

table tbody tr > td {
  border-width: 0;
  padding: 0 14px;
}

table tfoot tr > td {
  border-width: 0;
}

table > thead > tr > th:not(:first-child):not(:last-child),
table > tbody > tr > td:not(:first-child):not(:last-child) {
  border-left-width: 1px;
  border-right-width: 1px;
}

table > tbody > tr:last-child > td {
  border-bottom-width: 1px;
}

@media print {
  ._a4-paper {
    height: calc(29.7cm - 48px) !important;
    margin: 0 !important;
    box-shadow: unset !important;
  }
}
</style>
